import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enCourses from './locales/en/courses.json';
import enProfile from './locales/en/profile.json';
import enNav from './locales/en/nav.json';
import enHome from './locales/en/home.json';
import enAbout from './locales/en/about.json';
import enPartners from './locales/en/partners.json';
import enMeetFounder from './locales/en/meetFounder.json';
import enHowItWorks from './locales/en/howItWorks.json';

import arCommon from './locales/ar/common.json';
import arAuth from './locales/ar/auth.json';
import arCourses from './locales/ar/courses.json';
import arProfile from './locales/ar/profile.json';
import arNav from './locales/ar/nav.json';
import arHome from './locales/ar/home.json';
import arAbout from './locales/ar/about.json';
import arPartners from './locales/ar/partners.json';
import arMeetFounder from './locales/ar/meetFounder.json';
import arHowItWorks from './locales/ar/howItWorks.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    courses: enCourses,
    profile: enProfile,
    nav: enNav,
    home: enHome,
    about: enAbout,
    partners: enPartners,
    meetFounder: enMeetFounder,
    howItWorks: enHowItWorks
  },
  ar: {
    common: arCommon,
    auth: arAuth,
    courses: arCourses,
    profile: arProfile,
    nav: arNav,
    home: arHome,
    about: arAbout,
    partners: arPartners,
    meetFounder: arMeetFounder,
    howItWorks: arHowItWorks
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'courses', 'profile', 'nav', 'home', 'about', 'partners', 'meetFounder', 'howItWorks'],
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'faheem_language'
    },
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: false
    }
  });

export default i18n;
